import {
    apiRequest,
    legalCreate,
} from "../../../../../services/adapters/master/legalService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", legalCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository